<template>
  <div>
    <page-section :title="$t('Integrations_Title_Information')">
      <form-section>
        <p class="item-description">
          {{ $t('Integrations_Magento_Text_TokenInfo') }}
        </p>
        <integration-token-box :token="model.token" />
        <p class="item-description">
          {{ $t('Integrations_Magento_Text_EndpointsInfo') }}
        </p>

        <el-table :data="tableData" stripe>
          <el-table-column
            prop="api"
            :label="$t('Integrations_Magento_Text_EndpointType')"
            width="180"
          />
          <el-table-column
            prop="endpoint"
            :label="$t('Integrations_Magento_Text_Endpoint')"
          />
        </el-table>
      </form-section>
    </page-section>

    <integration-tasks-table
      :integration-id="model.id"
      :task-identifiers="[
        'magento_fetch_profile_data',
        'magento_fetch_purchase_data'
      ]"
    />
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import IntegrationTokenBox from '@/modules/integrations/components/IntegrationTokenBox'
import IntegrationTasksTable from '@/modules/integrations/components/IntegrationTasksTable'
import PageSection from '@/common/components/page/PageSection'

export default {
  name: 'MagentoOverview',

  components: {
    FormSection,
    IntegrationTasksTable,
    IntegrationTokenBox,
    PageSection
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  computed: {
    tableData() {
      let apiEndpoint = this.$store.state.app.domains.api
      return [
        {
          api: this.$t('Integrations_ApiEndpoint'),
          endpoint: `https://${apiEndpoint}`
        }
      ]
    }
  }
}
</script>

<style scoped>
.item-description {
  color: #808080;
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/magento/MagentoOverview.vue